var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21825 1.66887L8.25247 3.71304L3.10329 8.88745L1.07021 6.84328L6.21825 1.66887ZM9.79606 1.17586L8.88887 0.264235C8.53827 -0.0880783 7.96898 -0.0880783 7.61719 0.264235L6.21825 1.66887L7.28283 2.73866L8.25247 3.71304L9.79606 2.16307C10.068 1.8898 10.068 1.44912 9.79606 1.17586ZM0.00566077 9.71652C-0.0313595 9.88395 0.119066 10.034 0.285695 9.99325L2.5525 9.44095L0.519426 7.39678L0.00566077 9.71652Z",
    fill: "#000000"
  })));
}

export default SvgEditIcon;